var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isMajorOrDiscountItem)?_c('div',{class:_vm.cartTagDisplay[_vm.item.cartTag]?.style},[_vm._v(" "+_vm._s(_vm.cartTagDisplay[_vm.item.cartTag]?.text)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }